import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Property Manager",
    role: "Condominium",
    quote:
      "In 2007 it was decided we would use a security firm to improve safety and general property security for the residents at one location. ARGUS Security approached me to understand our needs and established the relevant site security. The Argus Security team's ability to understand my unique security challenges, and their willingness to find a viable solution made it clear I wasn’t dealing with just any security company. When the Argus Security team was ready to begin patrolling the site, I was impressed to learn site specific training was provided to all guards and all within my budget. Argus’s commitment to customer service, thorough knowledge of the security industry and professional approach were the reasons I chose to work with them. Working with Argus Security I have experienced the honest and fair way they treat those around them. Over the years Argus Security International Inc. has become a trusted advisor for me, when it comes to security either personal or professional. As a property manager I have no trouble recommending Argus Security International Inc to any business owner looking for a security solution or advisor that has their best interest in mind.",
  },
  {
    name: "President",
    role: "Distribution / Wholesale",
    quote:
      "Argus Security International and I have been working together since 2007. Although Luke wasn’t the first security supervisor I had met, his approach and commitment to the job surpassed any others I’d worked with previously. As a local businessman operating various fragrance and cosmetic related events it wasn’t until Mr. Pratt and his team took over security that it became clear how valuable a proactive, customized security plan can be. Argus Security International continues to stand out and impress me with each project we do, taking on more responsibility and even working with relevant government parties to ensure adherence to municipal by-laws. I look forward to working with Argus Security International over the coming years as my security advisor. Luke’s experience and knowledge have been of great assistance and I would gladly recommend him to any considering guard services.",
  },
  {
    name: "Project Manager",
    role: "Construction",
    quote:
      "The ARGUS guards are dependable and detail focused. When high winds caused damage to our construction site, their use of technology and digital reports eliminated beyond a doubt exactly what happened, making it much easier to recover the loss.",
  },
];

function TestimonialCard({ quote, name, role, index }) {
  const [showFull, setShowFull] = useState(false);
  const limit = 300;
  const isLong = quote.length > limit;

  return (
    <motion.div
      className="min-w-[320px] sm:min-w-[420px] bg-gray-100 rounded-3xl shadow-lg p-8 snap-center hover:shadow-2xl transition-all duration-300 flex flex-col justify-between mx-2"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.15 }}
    >
      <div className="text-gray-700 text-base leading-relaxed mb-6 relative">
        <span className="text-5xl absolute top-[-20px] left-[-10px] text-gray-300 select-none">“</span>
        {isLong && !showFull ? quote.slice(0, limit) + "..." : quote}
        {isLong && (
          <button
            className="text-blue-600 ml-2 underline text-sm"
            onClick={() => setShowFull(!showFull)}
          >
            {showFull ? "Read less" : "Read more"}
          </button>
        )}
        <span className="text-5xl absolute bottom-[-20px] right-[-10px] text-gray-300 select-none">”</span>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-300">
        <p className="text-lg font-semibold text-gray-900">{name}</p>
        <p className="text-sm text-gray-600">{role}</p>
      </div>
    </motion.div>
  );
}

export default function TestimonialCarousel() {
  const carouselRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const carousel = carouselRef.current;
    setWidth(carousel.scrollWidth - carousel.offsetWidth);
  }, []);

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-14">
          What Our Clients Say
        </h2>

        <motion.div
          ref={carouselRef}
          className="overflow-hidden cursor-grab active:cursor-grabbing"
        >
          <motion.div
            className="flex"
            drag="x"
            dragConstraints={{ right: 0, left: -width }}
            dragElastic={0.15}
          >
            {testimonials.map((t, i) => (
              <TestimonialCard key={i} {...t} index={i} />
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
